import { getSecondsInTimeInterval } from 'client/modules/Date';
import { TimeInterval } from 'client/modules/Date/types';
import { getApiUrl } from 'client/modules/Url';

export type FetchStationPlaysByEpisodeProps = {
  webStationId: string;
  timeInterval: TimeInterval;
  range?: {
    timeRangeStart: number; // epoch time
    timeRangeEnd: number;
  };
  limit: number;
};

export type FetchStationPlaysByEpisodeResponse = {
  data: {
    columnHeaders: [
      { name: string; type: string },
      { labelKey: string; type: string },
      { name: string; type: string }
    ];
    labels: {
      EpisodeTitle: {
        [index: string]: string;
      };
    };
    rows: [number, string, number][]; // [dateTimestamp, titleIndex, numOfPlays]
  };
  kind: 'playsByEpisode';
  parameters: {
    limit: number;
    timeInterval: number;
    timeRange: [number, number];
  };
  stationId: number;
};

export async function fetchStationPlaysByEpisode({
  webStationId,
  timeInterval = 'hour',
  range,
  limit,
}: FetchStationPlaysByEpisodeProps): Promise<FetchStationPlaysByEpisodeResponse> {
  try {
    const url = getApiUrl({
      path: `analytics/station/webStationId:${webStationId}/playsByEpisode`,
      queryParameters: {
        timeInterval: getSecondsInTimeInterval(timeInterval),
        limit,
        ...(range && {
          timeRangeStart: range.timeRangeStart,
          timeRangeEnd: range.timeRangeEnd,
        }),
      },
    });
    const resp = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
    });

    if (resp.ok) {
      return resp.json();
    }

    throw new Error(
      'Could not fetch station top played episodes by date range'
    );
  } catch (err) {
    throw new Error(err.message);
  }
}
